module.exports = __webpack_public_path__ + "img/sleep.694cd84d.png";